function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.8774 4.07118L10.0857 0.133722C9.96202 0.00544327 9.77244 -0.0348242 9.60741 0.0316118C9.44175 0.0986887 9.33323 0.259118 9.33323 0.437598V2.33348H9.18744C6.05149 2.33348 3.5 4.88497 3.5 8.02092V8.89591C3.5 9.09885 3.64291 9.26803 3.84062 9.31418C3.87277 9.32229 3.90481 9.32582 3.93685 9.32582C4.10198 9.32582 4.26006 9.22894 4.33643 9.07674C5.15663 7.43581 6.80567 6.41673 8.64025 6.41673H9.33323V8.31251C9.33323 8.4911 9.44175 8.65152 9.60741 8.71796C9.77137 8.78504 9.96202 8.74424 10.0857 8.61585L13.8774 4.67839C14.0407 4.50867 14.0407 4.24154 13.8774 4.07118Z",
  fill: "#7E8897"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.2499 14H1.74998C0.785162 14 0 13.2149 0 12.25V4.08348C0 3.11866 0.785162 2.3335 1.74998 2.3335H3.49996C3.82253 2.3335 4.08325 2.59422 4.08325 2.91679C4.08325 3.23935 3.82253 3.50008 3.49996 3.50008H1.74998C1.42795 3.50008 1.16658 3.76144 1.16658 4.08348V12.25C1.16658 12.572 1.42795 12.8334 1.74998 12.8334H12.2499C12.5718 12.8334 12.8331 12.572 12.8331 12.25V7.58344C12.8331 7.26087 13.0939 7.00004 13.4164 7.00004C13.7391 7.00004 13.9998 7.26087 13.9998 7.58344V12.25C13.9998 13.2149 13.2147 14 12.2499 14Z",
  fill: "#7E8897"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 14,
  fill: "white"
})));

function SvgShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.59b411de.svg";
export { ForwardRef as ReactComponent };